/**
 * errorPolicy 'none' is Apollo's own default, and it's the correct one here.
 *
 * With 'all' / 'ignore' Apollo didn't throw: the promise resolved with
 * data: null and the service layer's data.<field> access threw
 * "TypeError: Cannot read properties of null". The real error (JWT INVALID)
 * ended up hidden behind a generic TypeError in Sentry.
 *
 * With 'none' the client.query await rejects before data.<field> is ever
 * evaluated, so the ApolloError reaches React Query and Sentry intact.
 *
 * mutate is spelled out even though its default is already 'none': the key
 * was missing and its absence read as an oversight. Note this doesn't cover
 * every write — the ones that travel through client.query are governed by
 * query.errorPolicy instead.
 */
export const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'none',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'none',
  },
  mutate: {
    errorPolicy: 'none',
  },
}
